var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleVan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    viewBox: "0 0 19 15.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-truck",
    "data-name": "Icon metro-truck",
    d: "M21.571,14.1,19.2,9.347H15.633V6.972a1.191,1.191,0,0,0-1.187-1.187H3.758A1.191,1.191,0,0,0,2.571,6.972v9.5l1.187,1.188H5.264a2.375,2.375,0,1,0,4.113,0h6.575a2.375,2.375,0,1,0,4.113,0h1.506V14.1Zm-5.937,0V10.534h2.462L19.876,14.1H15.633Z",
    transform: "translate(-2.571 -5.784)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleVan);
export default __webpack_public_path__ + "static/media/Vehicle_Van.38a9e8fe58e6d311b84af88c8be6eb62.svg";
export { ForwardRef as ReactComponent };